import * as z from "zod"
import { emailSchema } from "./LoginFormSchema"

export const signupFormSchema = z.object({
   email: emailSchema,
   firstName: z
      .string()
      .min(2, { message: "First name must be at least 2 characters" })
      .max(50, { message: "First name cannot exceed 50 characters" })
      .regex(/^[A-Za-z\s\-']+$/, { message: "First name can only contain letters, spaces, hyphens, and apostrophes" })
      .refine((val) => val.trim() === val && val.length > 0, {
         message: "First name cannot have leading or trailing spaces or be empty",
      }),
   lastName: z
      .string()
      .min(2, { message: "Last name must be at least 2 characters" })
      .max(50, { message: "Last name cannot exceed 50 characters" })
      .regex(/^[A-Za-z\s\-']+$/, { message: "Last name can only contain letters, spaces, hyphens, and apostrophes" })
      .refine((val) => val.trim() === val && val.length > 0, {
         message: "Last name cannot have leading or trailing spaces or be empty",
      }),
   company: z
      .string()
      .min(2, { message: "Company name must be at least 2 characters" })
      .max(100, { message: "Company name cannot exceed 100 characters" })
      .regex(/^[A-Za-z0-9\s\-']+$/, {
         message: "Company name can only contain letters, numbers, spaces, hyphens, and apostrophes",
      })
      .refine((val) => val.trim() === val && val.length > 0, {
         message: "Company name cannot have leading or trailing spaces or be empty",
      }),
   phone: z
      .string()
      .min(10, { message: "Phone number must be at least 10 digits long" })
      .max(15, { message: "Phone number cannot exceed 15 digits" })
      .regex(/^\+?[1-9]\d{1,14}$/, { message: "Phone number must be a valid international format" }),
   password: z
      .string()
      .min(6, { message: "Password must be at least 6 characters long" })
      .max(32, { message: "Password cannot exceed 32 characters" })
      .regex(/^(?=.*[0-9]).{6,}$/, { message: "Password must contain at least 6 characters and one number" }),
})

export type SignupFormInputs = z.infer<typeof signupFormSchema>
